export default "__VITE_ASSET__5afd2a27__"